$(document).ready(function() {
    resizeSlideshow();

    $(window).resize(function() {
        resizeSlideshow();
    });

    UIkit.util.on('.gallery-slideshow', 'itemshow', function(event, args) {
        $('.gallery-navigation progress').val(args.index + 1);
    })

    let slideshowHomeClass = '.slider',
        slideshowHome = UIkit.slideshow(slideshowHomeClass);

    if (slideshowHome) {
        setSlideshowRatio(slideshowHome);
    }

    $(window).resize(function() {
        setSlideshowRatio(slideshowHome);
    })

    UIkit.util.on('.gallery-slider', 'itemshow', function(event, args) {
        $('.gallery-slider-navigation progress').val(args.index + 1);
    })
})

let resizeSlideshow = function() {
    let galleryGridHeight = $('.uk-active .gallery-image-grid').height();
    $('.uk-slideshow-items').css('min-height', galleryGridHeight);
}

let setSlideshowRatio = function (slideshow) {
    let $slideshow = $('.slider'),
        desktopRatio = '12:5',
        tabletRatio = '12:7',
        mobileRatio = '2:3';

    if (!$slideshow.length) return;

    if (window.innerWidth <= 639) {
        slideshow.ratio = mobileRatio;
    } else if (window.innerWidth >= 640 && window.innerWidth <= 1199) {
        slideshow.ratio = tabletRatio;
    } else {
        slideshow.ratio = desktopRatio;
    }
}
